import React, { useEffect } from 'react';
import styled from 'styled-components';
import { BounceLoader } from 'react-spinners';

import { Flex } from '../atom/Layout';
import ThemeStyle from '../../../lib/style/ThemeStyle';

const Container = styled(Flex)`
  height: 50vh;
`;

const Text = styled.div`
  margin-top: 20px;
`;

const OrderLoading = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Container column>
      <BounceLoader color={ThemeStyle.color.orangePink} />
      <Text>결제중입니다</Text>
    </Container>
  );
};

export default OrderLoading;
